import styled from 'styled-components'
import { ChicletMenu } from '../ChicletMenu'
import { Tag } from '../Tag'
import { useStateValue } from 'providers'
import { useEffect, useState } from 'react'

const API_URL = process.env.API_URL

const Filters = styled(ChicletMenu)`
  position: absolute;
  left: 1rem;
  bottom: ${({ $showBackButton }) => ($showBackButton ? '4rem' : '0.5rem')};
  z-index: 99999;
`

const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  border-radius: 0.5rem;
  min-width: 12rem;
  ${({ theme: { colors } }) => `
    background: ${colors('foreground')};
    box-shadow: 0 4px 12px ${colors('background', 0.3)};
  `}
`

const ActiveTags = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const SearchInput = styled.input`
  border: 0 none;
  outline: 0 none;
  padding: 0.25rem 0.5rem;
  margin: 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.85rem;
  width: 10rem;
  ${({ theme: { colors } }) => `
    background: ${colors('foreground')};
    color: ${colors('background')};
  `}
`

export const MapFilters = ({ onChange, showBackButton = true }) => {
  const [{ session: { token } }] = useStateValue()
  const [active, setActive] = useState([])
  const [term, setTerm] = useState('')
  const [suggestions, setSuggestions] = useState([])

  useEffect(() => {
    if (!term) return setSuggestions([])
    const timer = setTimeout(() => {
      fetch(`${API_URL}/tags?q=${encodeURIComponent(term)}`, {
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `JWT ${token}` } : {})
        }
      })
        .then((r) => r.json())
        .then((d) => setSuggestions(d?.tags?.rows || []))
    }, 300)
    return () => clearTimeout(timer)
  }, [term])

  const selectTag = (tag) => {
    if (active.some((t) => t.id === tag.id)) return
    setActive([...active, tag])
    setTerm('')
    setSuggestions([])
  }

  const removeTag = (tag) => {
    setActive(active.filter((t) => t.id !== tag.id))
  }

  useEffect(() => {
    onChange(active.map((t) => t.name).join('|'))
  }, [active])

  return (
    <Filters icon="filter-outline" $showBackButton={showBackButton}>
      <PopoverContent>
        <SearchInput
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          placeholder="Search tags…"
        />
        {active.length > 0 && (
          <ActiveTags>
            {active.map((tag) => (
              <Tag key={tag.id} className="active" onClick={() => removeTag(tag)}>
                {tag.name} ×
              </Tag>
            ))}
          </ActiveTags>
        )}
        {suggestions
          .filter((tag) => !active.some((a) => a.id === tag.id))
          .map((tag) => (
            <Tag key={tag.id} onClick={() => selectTag(tag)}>
              {tag.name}
            </Tag>
          ))}
      </PopoverContent>
    </Filters>
  )
}
